import React from "react";
import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";
import "./Plans.css";

const Plans = () => {
  return (
    <div className="plans-container" id="plansCard">
      <div className="blur plans-b-1"></div>
      <div className="blur plans-b-2"></div>
      <div className="programs-header" style={{ gap: "2rem" }}>
        <span className="stroke-text">READY TO START</span>
        <span>YOUR JOURNEY</span>
        <span className="stroke-text">NOW WITHUS</span>
      </div>
      {/* plans card */}

      <div className="plans">
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span className="name">{plan.name}</span>
            <span className="price">$ {plan.price}</span>

            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature">
                  <img
                    style={{
                      width: "1rem",
                      height: "1rem",
                      paddingRight: "1rem",
                    }}
                    src={whiteTick}
                    alt=""
                  />
                  <span key={i}>{feature}</span>
                </div>
              ))}
            </div>
            <div className="senten">
              <span>See more benefits</span>
            </div>
            <button style={{ marginTop: "2rem" }} className="btn">
              Join now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plans;
